/**
 * O aviso na tela do portal já configurado (D3, passo 19 — PR 2): o destino é validado por `caminhoSeguroDoPortal` (o do interno devolve
 * `null` para `/portal/*` de propósito), "Ver todas" e o corpo sem destino levam às notificações do Início, e as categorias são as do portal.
 */
import { criarAvisoNaTela } from "@/components/notifications/AvisoNaTela";
import { CATEGORIAS_DO_PORTAL } from "@/components/notifications/categoriasDeAviso";
import { caminhoSeguroDoPortal } from "@/lib/portal/caminhoSeguro";

/** Não há rota de notificações no portal: a lista é o painel do Início (`PortalInicio` rola até ele pelo hash). */
export const INBOX_DO_PORTAL = "/portal/inicio#notificacoes";

export const mostrarAvisoDoPortal = criarAvisoNaTela({
  caminhoSeguro: caminhoSeguroDoPortal,
  inbox: INBOX_DO_PORTAL,
  categorias: CATEGORIAS_DO_PORTAL,
});
